module.exports = __webpack_public_path__ + "img/Large-Horizontal-Rectangular-Attachment-32.5fb19abc.png";